import { VenueSchedule } from '../@types/venue';

type VenueScheduleLike = Pick<VenueSchedule, 'weekday' | 'from'> & {
  week_day?: number | null;
};

function getWeekDay(item: VenueScheduleLike): number {
  return item.week_day ?? item.weekday ?? 0;
}

function getFromTimeMinutes(from: Date | string | number | null | undefined): number {
  if (from == null) {
    return 0;
  }

  const date = new Date(from);
  if (Number.isNaN(date.getTime())) {
    return 0;
  }

  return date.getUTCHours() * 60 + date.getUTCMinutes();
}

export function sortVenueSchedule<T extends VenueScheduleLike>(schedule: T[]): T[] {
  return [...schedule].sort((a, b) => {
    const dayDiff = getWeekDay(a) - getWeekDay(b);
    if (dayDiff !== 0) {
      return dayDiff;
    }

    return getFromTimeMinutes(a.from) - getFromTimeMinutes(b.from);
  });
}
